<script>
    export let API_URL;
    import { user } from './stores.js'

    function signIn() {
        $user = null;

        console.log("sign in");
        const form = document.getElementById("signInForm");

        const email = form.elements["email"].value;
        const pass = form.elements["password"].value;

        const url = `${API_URL}/api/auth/signin`;
        // document.getElementById("word-definition-error").innerHTML = "";
        // linked = [];

        const data = {
            email: email,
            password: pass,
        }

        const response = fetch(url, {
            method: 'POST',
            mode: 'cors',
            body: JSON.stringify(data),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        }).then(data => {
            if (data.status === 200) {
                console.log("OK...", data);
                data.json().then(j => {
                    if (j) {
                        console.log("j", j)
                        // const data = JSON.parse(j.body);
                        console.log("d", j.token);
                        // $isAuthenticated = true;
                        $user = {token: j.token};
                        window.location = "/notes";
                        // if (j.linked && j.linked.data) {
                        //     linked = JSON.parse(j.linked.data)
                        //     linkedWord = j.linked.word;
                        // }

                        // definition = d;
                        // currentWord = j.word;
                    } else {
                        // Not found
                        // definition = [];
                        // currentWord = "";
                        // linkedWord = "";
                        // linked = [];
                        // document.getElementById("word-definition-error").innerHTML = `<b>${word}</b> not found`;
                    }
                })
            } else {
                // definition = [];
                // currentWord = "";
                // linkedWord = "";
                // linked = [];
                // document.getElementById("word-definition-error").innerHTML = `<b>${word}</b> not found`;
            }
        });
    }

</script>

<div class="container-fluid">
    <div class="row row-example">
        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4">

        </div>
        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <h1>Sign In</h1>

            <form action="#" id="signInForm">
                <input type="text" name="email" placeholder="Email"/>
                <input type="password" name="password" placeholder="Password"/>
                <button type="button" on:click={signIn}>Sign in</button>
            </form>
        </div>
        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4">

        </div>
    </div>
</div>



<!--
<style lang="scss">
    .about {
        margin-right: 0.5rem;
        margin-left: 0.5rem;
        padding-top: 7rem;
		max-width: 768px;
	}
    .contrib-table {
        margin: 2rem;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        column-gap: 0.5rem;
        row-gap: 1rem;
    }
    .contrib-item {
        text-align: center;
    }
    @media (min-width: 1080px) {
        .contrib-table {
            grid-template-columns: repeat(6, 1fr);
        }
        .about {
            margin: auto;
        }
    }
</style> -->
